import { Component, Input, input } from '@angular/core';
import { BrowserModule } from "@angular/platform-browser";

@Component({
  selector: 'app-cycle-status',
  standalone: true,
  imports: [BrowserModule],
  templateUrl: './cycle-status.component.html',
  styleUrl: './cycle-status.component.scss'
})
export class CycleStatusComponent {
    @Input() cyclePhase:  { state: string, day?: string | null, trimester?: string };
}
